import { useState } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/dahbb3joh653ivfvnqag";

type Status = "idle" | "loading" | "success" | "error";

export default function NewsletterForm({ variant = "footer" }: { variant?: "footer" | "block" }) {
  const [status, setStatus] = useState<Status>("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const payload = new FormData(form);

    const honeypot = String(payload.get("contact_alt") ?? "").trim();
    payload.delete("contact_alt");

    if (honeypot) {
      setStatus("success");
      setMessage("订阅成功，每周鉴定播报会发送到你的邮箱。");
      return;
    }

    setStatus("loading");
    setMessage("");

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(payload as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg = String(
        parsed?.meta?.message || parsed?.meta?.detail || parsed?.message || responseText || ""
      );
      const failed =
        !response.ok ||
        String(parsed?.code || "") !== "OK" ||
        /spam/i.test(serverMsg);

      if (failed) {
        setStatus("error");
        setMessage(serverMsg || "订阅失败，请稍后重试。");
        return;
      }

      setStatus("success");
      setMessage("订阅成功，每周鉴定播报会发送到你的邮箱。");
      form.reset();
    } catch {
      setStatus("error");
      setMessage("网络异常，订阅未能提交，请稍后再试。");
    }
  };

  const isFooter = variant === "footer";

  const msgClass =
    status === "error"
      ? isFooter
        ? "text-accent-300"
        : "text-primary-600"
      : isFooter
        ? "text-secondary-200"
        : "text-secondary-700";

  return (
    <form
      id={isFooter ? "subscribe-form-footer" : "subscribe-form-block"}
      data-readdy-form
      onSubmit={handleSubmit}
      className="w-full"
    >
      <div className="flex flex-col sm:flex-row gap-2">
        <label className="flex-1">
          <span className="sr-only">电子邮箱</span>
          <input
            type="email"
            name="email"
            required
            autoComplete="email"
            placeholder="输入邮箱，订阅每周鉴定播报"
            className="w-full px-4 py-2.5 text-sm rounded-control border border-background-300 bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300"
          />
        </label>
        <input
          type="text"
          name="contact_alt"
          className="form-honeypot-redirect"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
        />
        <button
          type="submit"
          disabled={status === "loading"}
          className="px-5 py-2.5 text-sm font-medium rounded-control bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap disabled:opacity-60"
        >
          {status === "loading" ? "提交中…" : "立即订阅"}
        </button>
      </div>
      {message && (
        <p role="status" className={`mt-2 text-xs ${msgClass}`}>
          {message}
        </p>
      )}
    </form>
  );
}